import { useGet } from './useHttpHooks';
import { CategorisedQuestionsAndArticles } from '../types';
import toQuery from '../lib/toQuery';

type QuestionsAndArticlesByCategoryQuery = { tagText: string };

const useGetQuestionsAndArticlesByCategory = (
    request: QuestionsAndArticlesByCategoryQuery
) =>
    useGet<CategorisedQuestionsAndArticles>(
        `/api/help-page/questions-and-articles-by-category?${toQuery(request)}`,
        {
            errorMessage:
                'GET /api/help-page/questions-and-articles-by-category failed'
        }
    );

export default useGetQuestionsAndArticlesByCategory;
